import React from "react"

import { useAppSelector } from "../../../../../../hooks/use-app-selector.ts"
import { getEntityName } from "../../../../../../utils/user/get-entity-name.ts"
import { RecordCommunicationTimeline } from "../../../../../Communication/timeline/RecordCommunicationTimeline.tsx"

const ProjectViewCommunicationSection = () => {
  const project = useAppSelector((state) => state.project.project)
  if (!project) return null
  return (
    <RecordCommunicationTimeline
      scope={{ lead: project.id }}
      composerTarget={{
        record: { type: "project", id: project.id },
        recipient: project.customer
          ? { type: "customer", id: project.customer.id }
          : { type: "lead", id: project.id },
        recipientName: getEntityName(
          project.customer || project.temporary_customer
        )
      }}
    />
  )
}

export default ProjectViewCommunicationSection
